var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-detail",
    },
    [
      _c(
        "div",
        { staticClass: "page-group" },
        [
          _c("el-button", {
            staticClass: "page-btn",
            attrs: {
              size: "small",
              icon: "el-icon-arrow-left",
              disabled: _vm.pageIndex === 0,
            },
            on: {
              click: function ($event) {
                return _vm.onPage(-1)
              },
            },
          }),
          _c("el-button", {
            staticClass: "page-btn",
            attrs: {
              size: "small",
              icon: "el-icon-arrow-right",
              disabled:
                !_vm.pageList || _vm.pageIndex === _vm.pageList.length - 1,
            },
            on: {
              click: function ($event) {
                return _vm.onPage(1)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            {
              staticClass: "detail-wrapper",
              attrs: { lg: 16, md: 16, sm: 12 },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "title-line",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.$t("stores::order::order_info"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right-ctl-wrapper" },
                        [
                          _vm.orderDetail.payStatus === 0
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "stores::order::cancel",
                                      expression: "'stores::order::cancel'",
                                    },
                                  ],
                                  staticClass: "ctl-btn",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.isCancelModalShow = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("stores::order::cancel_order")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          [1].some(function (i) {
                            return i === _vm.orderDetail.payStatus
                          }) &&
                          [0].some(function (i) {
                            return i === _vm.orderDetail.salesStatus
                          })
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "stores::order::after",
                                      expression: "'stores::order::after'",
                                    },
                                  ],
                                  staticClass: "ctl-btn",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        path: "/add-after-order",
                                        query: {
                                          orderNo: _vm.$route.params.id,
                                        },
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("stores::order::to_after_sales")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-row",
                    { staticClass: "row-item", attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::platform_order")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.orderNo))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::belong_platform")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.PLATFORM[_vm.orderDetail.mallType]
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::belong_store")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.shopName))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::store_order")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.sourceNo))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::create_time")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.createTime))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "mb-16", attrs: { span: 12 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::order_time")) +
                              "： "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.payTime))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      ![0, 7].some(function (i) {
                        return i === _vm.orderDetail.orderStatus
                      })
                        ? _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                type: [4].some(function (i) {
                                  return i === _vm.orderDetail.orderStatus
                                })
                                  ? "success"
                                  : "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.orderStatus[_vm.orderDetail.orderStatus]
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.orderDetail.fulfillmentStatus
                        ? _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                type: [6].some(function (i) {
                                  return i === _vm.orderDetail.fulfillmentStatus
                                })
                                  ? "success"
                                  : "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.FULFILMENTSTATUS[
                                      _vm.orderDetail.fulfillmentStatus
                                    ]
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            type: [1, 5, 6].some(function (i) {
                              return i === _vm.orderDetail.payStatus
                            })
                              ? "success"
                              : "warning",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.PAY_STATUS[_vm.orderDetail.payStatus]
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.orderDetail.salesStatus > 0
                        ? _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                type: [2, 4].some(function (i) {
                                  return i === _vm.orderDetail.salesStatus
                                })
                                  ? "success"
                                  : "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.SALES_STATUS[
                                      _vm.orderDetail.salesStatus
                                    ]
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("el-divider", { staticClass: "full-divider mb-0" }),
                  _c(
                    "div",
                    { staticClass: "goods-wrap" },
                    _vm._l(_vm.orderDetail.orderItems, function (row) {
                      return _c(
                        "div",
                        { key: row.orderItemNo, staticClass: "goods-item" },
                        [
                          _c("ZImg", {
                            staticClass: "order-item-img",
                            attrs: {
                              "preview-src-list": [row.imageUrl],
                              src: row.imageUrl,
                              alt: "",
                              fit: "contain",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "goods-title" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: row.title,
                                    effect: "dark",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex order-item-title-box",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "order-item-title",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push(
                                                "/products-info/detail/" +
                                                  row.spuId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(row.title) + " ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("p", { staticClass: "order-item-desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dataCheck(row.variantOptionValue)
                                    ) +
                                    _vm._s(
                                      _vm.filterVariant(
                                        row.variantCustomizedOption
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("p", { staticClass: "order-item-desc" }, [
                                _vm._v(
                                  "SPU ID：" + _vm._s(_vm.$dataCheck(row.spuId))
                                ),
                              ]),
                              _c("p", { staticClass: "order-item-desc" }, [
                                _vm._v(
                                  "SKU ID：" +
                                    _vm._s(_vm.$dataCheck(row.variantId))
                                ),
                              ]),
                              _c("p", { staticClass: "order-item-desc" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("system::responsible::供应商")
                                  ) +
                                    "：" +
                                    _vm._s(_vm.$dataCheck(row.supplier))
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "goods-price" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumberMix")(row.variantPrice)
                                ) +
                                " " +
                                _vm._s(row.currency || "") +
                                " x " +
                                _vm._s(row.quantity) +
                                " "
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "goods-price",
                              staticStyle: {
                                color: "#010517",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumberMix")(row.saleAmount)
                                  ) +
                                  " " +
                                  _vm._s(row.currency || "") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c("el-divider", { staticClass: "full-divider mt-0" }),
                  _c("div", { staticClass: "row-sale-wrapper" }, [
                    _c("div", { staticClass: "sale-item" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("stores::order::goods")) + "："),
                      ]),
                      _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumberMix")(
                                _vm.$dataCheck(_vm.orderDetail.itemsAmount, 0)
                              )
                            ) +
                            " " +
                            _vm._s(_vm.orderDetail.currency) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "sale-item" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("stores::order::freight")) + "："),
                      ]),
                      _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumberMix")(
                                _vm.$dataCheck(_vm.orderDetail.payShipAmount, 0)
                              )
                            ) +
                            " " +
                            _vm._s(_vm.orderDetail.currency) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "sale-item" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("stores::order::tax_amount")) + "："
                        ),
                      ]),
                      _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumberMix")(
                                _vm.$dataCheck(_vm.orderDetail.taxAmount, 0)
                              )
                            ) +
                            " " +
                            _vm._s(_vm.orderDetail.currency) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "sale-item" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("stores::order::discount")) + "："
                        ),
                      ]),
                      _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumberMix")(
                                _vm.$dataCheck(
                                  _vm.orderDetail.discountsAmount,
                                  0
                                )
                              )
                            ) +
                            " " +
                            _vm._s(_vm.orderDetail.currency) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "sale-item" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("stores::order::order_fee")) + "："
                        ),
                      ]),
                      _c("span", { staticClass: "info" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumberMix")(
                                _vm.$dataCheck(
                                  _vm.orderDetail.payTotalAmount,
                                  0
                                )
                              )
                            ) +
                            " " +
                            _vm._s(_vm.orderDetail.currency) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "order-stream-wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title-line",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _c("span", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("stores::order::shipping_info"))
                          ),
                        ]),
                        _c("span", { staticClass: "order-stream-type" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::order::deliver_plan")) +
                              ": "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(_vm.orderDetail.shippingTitle)
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right-ctl-wrapper" },
                        [
                          (_vm.orderDetail.orderItems || []).some(function (
                            item
                          ) {
                            return (
                              item.fulfillmentStatus === 1 ||
                              item.fulfillmentStatus === 2
                            )
                          }) &&
                          [1].some(function (i) {
                            return i === _vm.orderDetail.payStatus
                          })
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "stores::order::ship",
                                      expression: "'stores::order::ship'",
                                    },
                                  ],
                                  staticClass: "ctl-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.handleSend },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("stores::order::deliver")) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.orderDetail.fulfillments &&
                          _vm.orderDetail.fulfillments.filter(function (i) {
                            return i.fulfillmentStatus === 3
                          }).length &&
                          [2, 3, 5].some(function (i) {
                            return i === _vm.orderDetail.fulfillmentStatus
                          })
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "stores::order::deliver",
                                      expression: "'stores::order::deliver'",
                                    },
                                  ],
                                  staticClass: "ctl-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.markVisible = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("stores::order::mask_to_place")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.orderDetail.fulfillments &&
                  _vm.orderDetail.fulfillments.length
                    ? _vm._l(
                        _vm.orderDetail.fulfillments,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "mb-20" },
                            [
                              _c("div", { staticClass: "track-wrap" }, [
                                item.pushStatus === 1
                                  ? _c("div", { staticClass: "track-item" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("stores::order::fulfilments")
                                          ) +
                                          "：" +
                                          _vm._s(
                                            _vm.$dataCheck(item.trackingCompany)
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      { staticClass: "track-item" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "stores::order::fulfilments"
                                              )
                                            ) +
                                            "： "
                                        ),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "stores::order::cant_Identify"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              title: _vm.$t(
                                                "stores::order::fulfilments"
                                              ),
                                              trigger: "click",
                                            },
                                            on: {
                                              hide: function ($event) {
                                                _vm.shippingCompanyId = ""
                                              },
                                            },
                                            model: {
                                              value: item.showPopover,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "showPopover",
                                                  $$v
                                                )
                                              },
                                              expression: "item.showPopover",
                                            },
                                          },
                                          [
                                            _c("z-select", {
                                              attrs: {
                                                options: _vm.sendOptions,
                                              },
                                              model: {
                                                value: _vm.shippingCompanyId,
                                                callback: function ($$v) {
                                                  _vm.shippingCompanyId = $$v
                                                },
                                                expression: "shippingCompanyId",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "10px",
                                                  "tet-align": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.chooseDeliver(
                                                          item.fulfillmentId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "system::common::btn::confirm"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-edit-outline edit-icon",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                _c("div", { staticClass: "track-item" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("stores::order::shipping_time")
                                      ) +
                                      "：" +
                                      _vm._s(
                                        _vm.$dataCheck(item.fulfillmentTime)
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "track-item" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "stores::order::fulfilment_number"
                                        )
                                      ) +
                                      "：" +
                                      _vm._s(
                                        _vm.$dataCheck(item.trackingNumber)
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://17track.net/en#nums=" +
                                          item.trackingNumber,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("stores::order::check")
                                          ) +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "track-item" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("stores::order::status")) +
                                      "： "
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff9e00" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.fulfillmentStatus === 4
                                              ? _vm.$t(
                                                  "stores::order::online_not_sign"
                                                )
                                              : item.fulfillmentStatus === 6
                                              ? _vm.$t(
                                                  "stores::order::online_sign"
                                                )
                                              : _vm.$t(
                                                  "stores::order::not_online_not_sign"
                                                )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              item.fulfillmentItems.length > 3
                                ? _c(
                                    "div",
                                    { staticClass: "limitNumber mt-10" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "limit-img-wrap" },
                                        [
                                          _vm._l(
                                            item.fulfillmentItems,
                                            function (i, idx) {
                                              return [
                                                idx < 6
                                                  ? _c("ZImg", {
                                                      key: i.skuCode,
                                                      staticClass:
                                                        "order-item-img",
                                                      staticStyle: {
                                                        "margin-right": "10px",
                                                      },
                                                      attrs: {
                                                        "preview-src-list": [
                                                          i.imageUrl,
                                                        ],
                                                        src: i.imageUrl,
                                                        fit: "contain",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                          item.fulfillmentItems.length > 5
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "order-item-img flex-center",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-more",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "more-wrap",
                                          on: {
                                            click: function ($event) {
                                              item.showMore = !item.showMore
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "stores::order::fulfilment_goods",
                                                  {
                                                    goodsNum:
                                                      item.fulfillmentItems
                                                        .length,
                                                  }
                                                )
                                              )
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "more-btn" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.showMore
                                                      ? _vm.$t(
                                                          "stores::order::put_awary"
                                                        )
                                                      : _vm.$t(
                                                          "stores::order::open"
                                                        )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.showMore,
                                              expression: "item.showMore",
                                            },
                                          ],
                                          staticClass: "more-goods-wrap mt-10",
                                        },
                                        _vm._l(
                                          item.fulfillmentItems,
                                          function (row) {
                                            return _c(
                                              "div",
                                              {
                                                key: row.orderItemNo,
                                                staticClass: "goods-item",
                                              },
                                              [
                                                _c("ZImg", {
                                                  staticClass: "order-item-img",
                                                  attrs: {
                                                    "preview-src-list": [
                                                      row.imageUrl,
                                                    ],
                                                    src: row.imageUrl,
                                                    alt: "",
                                                    fit: "contain",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "goods-title",
                                                  },
                                                  [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          content: row.title,
                                                          effect: "dark",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex order-item-title-box",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "order-item-title",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$router.push(
                                                                        "/products-info/detail/" +
                                                                          row.spuId
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      row.title
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "order-item-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.variantOptionValue
                                                              )
                                                            ) +
                                                            _vm._s(
                                                              _vm.filterVariant(
                                                                row.variantCustomizedOption
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "order-item-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "SPU ID：" +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.spuId
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "order-item-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "SKU ID：" +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.variantId
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "order-item-desc",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "system::responsible::供应商"
                                                              )
                                                            ) +
                                                            "：" +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                row.supplier
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "goods-price",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumberMix"
                                                          )(row.variantPrice)
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          row.currency || ""
                                                        ) +
                                                        " x " +
                                                        _vm._s(row.quantity) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "goods-price",
                                                    staticStyle: {
                                                      color: "#010517",
                                                      "font-weight": "bold",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumberMix"
                                                          )(row.saleAmount)
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          row.currency || ""
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "goods-wrap" },
                                    _vm._l(
                                      item.fulfillmentItems,
                                      function (row) {
                                        return _c(
                                          "div",
                                          {
                                            key: row.orderItemNo,
                                            staticClass: "goods-item",
                                          },
                                          [
                                            _c("ZImg", {
                                              staticClass: "order-item-img",
                                              attrs: {
                                                "preview-src-list": [
                                                  row.imageUrl,
                                                ],
                                                src: row.imageUrl,
                                                alt: "",
                                                fit: "contain",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "goods-title" },
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: row.title,
                                                      effect: "dark",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex order-item-title-box",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "order-item-title",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.$router.push(
                                                                  "/products-info/detail/" +
                                                                    row.spuId
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.title
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "order-item-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            row.variantOptionValue
                                                          )
                                                        ) +
                                                        _vm._s(
                                                          _vm.filterVariant(
                                                            row.variantCustomizedOption
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "order-item-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "SPU ID：" +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            row.spuId
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "order-item-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "SKU ID：" +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            row.variantId
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "order-item-desc",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "system::responsible::供应商"
                                                          )
                                                        ) +
                                                        "：" +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            row.supplier
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "goods-price" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("formatNumberMix")(
                                                        row.variantPrice
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(row.currency || "") +
                                                    " x " +
                                                    _vm._s(row.quantity) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "goods-price",
                                                staticStyle: {
                                                  color: "#010517",
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("formatNumberMix")(
                                                        row.saleAmount
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(row.currency || "") +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ]
                          )
                        }
                      )
                    : _c("div", { staticClass: "no-stream-wrapper" }, [
                        _c("div", { staticClass: "no-stream-info" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("stores::order::not_deliver_tips")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "order-wrapper", attrs: { lg: 8, md: 8, sm: 12 } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    { staticClass: "order-info-title" },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("stores::order::customer_info"))),
                      ]),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "stores::order::edit",
                              expression: "'stores::order::edit'",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.editCustomer },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("stores::order::edit")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("First name:"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.firstName))),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("Last name:"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.lastName))),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("Phone NO:")]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.phone))),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("Email:")]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.email))),
                    ]),
                  ]),
                  _c("el-divider", { staticClass: "full-divider" }),
                  _c("div", { staticClass: "order-info-title" }, [
                    _vm._v(_vm._s(_vm.$t("stores::order::receiving_info"))),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::country")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingCountry))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::province")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingProvince))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::city")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingCity))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::street")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingAddress1))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::apartment")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingAddress2))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("Code:")]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.orderDetail.shippingZip))
                      ),
                    ]),
                  ]),
                  _c("el-divider", { staticClass: "full-divider" }),
                  _c("div", { staticClass: "order-info-title" }, [
                    _vm._v(_vm._s(_vm.$t("stores::order::billing_info"))),
                  ]),
                  _vm.orderDetail.firstName ===
                    _vm.orderDetail.billingFirstName &&
                  _vm.orderDetail.lastName ===
                    _vm.orderDetail.billingLastName &&
                  _vm.orderDetail.shippingAddress1 ===
                    _vm.orderDetail.billingAddress1 &&
                  _vm.orderDetail.shippingAddress2 ===
                    _vm.orderDetail.billingAddress2 &&
                  _vm.orderDetail.shippingZip === _vm.orderDetail.billingZip
                    ? _c("div", { staticClass: "cell-item" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("stores::order::same_address"))),
                        ]),
                      ])
                    : [
                        _c("div", { staticClass: "cell-item" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("Name:"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.billingFirstName) +
                                " " +
                                _vm._s(_vm.orderDetail.billingLastName)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "cell-item" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("Address:"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.billingAddress1) +
                                " " +
                                _vm._s(_vm.orderDetail.billingAddress2)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "cell-item" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("Code:"),
                          ]),
                          _c("span", { staticClass: "info" }, [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.orderDetail.billingZip))
                            ),
                          ]),
                        ]),
                      ],
                  _c("el-divider", { staticClass: "full-divider" }),
                  _c("div", { staticClass: "order-info-title" }, [
                    _vm._v(_vm._s(_vm.$t("stores::order::other_info"))),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::pay_type")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(
                        _vm._s(
                          _vm.payTypes[_vm.orderDetail.payType] ||
                            _vm.orderDetail.gateway
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::pay_time")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.payTime))),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::pay_number")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.paymentNo))),
                    ]),
                  ]),
                  _c("div", { staticClass: "cell-item" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("stores::order::utmSource")) + ":"),
                    ]),
                    _c("span", { staticClass: "info" }, [
                      _vm._v(_vm._s(_vm.$dataCheck(_vm.orderDetail.utmSource))),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "order-wrapper",
              staticStyle: { "margin-top": "16px" },
              attrs: { lg: 8, md: 8, sm: 12 },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "order-info-title",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-bewteen",
                        "align-items": "center",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("stores::order::售后信息")))]
                      ),
                      _vm.orderDetail.refundOrderVoList &&
                      _vm.orderDetail.refundOrderVoList.length
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#ff4d00",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("stores::order::剩余可退款金额")
                                  ) +
                                  " $" +
                                  _vm._s(
                                    _vm._f("formatNumberMix")(
                                      _vm.$dataCheck(_vm.refundTotalMoney, 0)
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm.orderDetail.refundOrderVoList &&
                  _vm.orderDetail.refundOrderVoList.length
                    ? _vm._l(
                        _vm.orderDetail.refundOrderVoList,
                        function (item) {
                          return _c(
                            "el-row",
                            {
                              key: item.id,
                              staticClass: "refund-item",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 14 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/after-order-detail/" + item.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item.refundNo) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm._f("formatNumberMix")(
                                          _vm.$dataCheck(item.amount, 0)
                                        )
                                      )
                                  ),
                                ]),
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "text-align": "end" },
                                  attrs: { span: 5 },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$dataCheck(
                                          _vm.refundStatus[item.status]
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            color: "#999",
                            "line-height": "40px",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("system::common::btn::no_data")) +
                              " "
                          ),
                        ]
                      ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("stores::order::edit_address"),
            visible: _vm.editVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: {
                    model: _vm.editForm,
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("stores::order::receiver") } },
                        [
                          _c("el-input", {
                            attrs: {
                              value:
                                _vm.editForm.firstName +
                                " " +
                                _vm.editForm.lastName,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "First Name", prop: "firstName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                _vm.$t("system::common::input_holder") +
                                "First Name",
                            },
                            model: {
                              value: _vm.editForm.firstName,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "firstName", $$v)
                              },
                              expression: "editForm.firstName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Last Name", prop: "lastName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                _vm.$t("system::common::input_holder") +
                                "Last Name",
                            },
                            model: {
                              value: _vm.editForm.lastName,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "lastName", $$v)
                              },
                              expression: "editForm.lastName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::email"),
                            prop: "email",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::email"),
                            },
                            model: {
                              value: _vm.editForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "email", $$v)
                              },
                              expression: "editForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::country"),
                            prop: "country",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder:
                                  "" +
                                  _vm.$t("system::common::select_placeholder") +
                                  _vm.$t("stores::order::city"),
                              },
                              on: { change: _vm.changeCountry },
                              model: {
                                value: _vm.editForm.countryCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "countryCode", $$v)
                                },
                                expression: "editForm.countryCode",
                              },
                            },
                            _vm._l(_vm.countries, function (i) {
                              return _c("el-option", {
                                key: i.code,
                                attrs: { label: i.name, value: i.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("stores::order::province") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder:
                                  "" +
                                  _vm.$t("system::common::select_placeholder") +
                                  _vm.$t("stores::order::city"),
                              },
                              on: { change: _vm.changeProvince },
                              model: {
                                value: _vm.editForm.provinceCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "provinceCode", $$v)
                                },
                                expression: "editForm.provinceCode",
                              },
                            },
                            _vm._l(_vm.provinces, function (i) {
                              return _c("el-option", {
                                key: i.code,
                                attrs: { label: i.name, value: i.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::city"),
                            prop: "city",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::city"),
                            },
                            model: {
                              value: _vm.editForm.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "city", $$v)
                              },
                              expression: "editForm.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::street"),
                            prop: "address1",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::street"),
                            },
                            model: {
                              value: _vm.editForm.address1,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "address1", $$v)
                              },
                              expression: "editForm.address1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("stores::order::apartment") },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::apartment"),
                            },
                            model: {
                              value: _vm.editForm.address2,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "address2", $$v)
                              },
                              expression: "editForm.address2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::phone"),
                            prop: "phone",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::phone"),
                            },
                            model: {
                              value: _vm.editForm.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "phone", $$v)
                              },
                              expression: "editForm.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("stores::order::zip"),
                            prop: "zip",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder:
                                "" +
                                _vm.$t("system::common::input_holder") +
                                _vm.$t("stores::order::zip"),
                            },
                            model: {
                              value: _vm.editForm.zip,
                              callback: function ($$v) {
                                _vm.$set(_vm.editForm, "zip", $$v)
                              },
                              expression: "editForm.zip",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("stores::order::mark"),
            visible: _vm.markVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.markVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "mark_wrap" },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("stores::order::select_fulfilment"))),
              ]),
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.trackingNumbers,
                    callback: function ($$v) {
                      _vm.trackingNumbers = $$v
                    },
                    expression: "trackingNumbers",
                  },
                },
                [
                  _vm._l(_vm.orderDetail.fulfillments, function (i) {
                    return [
                      i.fulfillmentStatus === 3
                        ? _c(
                            "el-checkbox",
                            {
                              key: i.trackingNumber,
                              staticClass: "checkbox-style",
                              attrs: { label: i.trackingNumber },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(i.trackingCompany) +
                                  " " +
                                  _vm._s(i.trackingNumber) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.markVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.markSubmit } },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("stores::order::message_cancel"),
            visible: _vm.isCancelModalShow,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isCancelModalShow = $event
            },
          },
        },
        [
          _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v(
              _vm._s(_vm.$t("stores::order::platform_order")) +
                "：" +
                _vm._s(_vm.orderDetail.orderNo)
            ),
          ]),
          _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v(
              _vm._s(_vm.$t("stores::order::store_order")) +
                "：" +
                _vm._s(_vm.orderDetail.sourceNo)
            ),
          ]),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("stores::order::message_cancel_tips"))),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isCancelModalShow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.cancelOrder } },
                [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ShipDialog", {
        attrs: { orderDetail: _vm.orderDetail },
        on: { getDetail: _vm.getDetail },
        model: {
          value: _vm.shipLoading,
          callback: function ($$v) {
            _vm.shipLoading = $$v
          },
          expression: "shipLoading",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }